import { useSyncExternalStore } from 'react';
import { useSearchParams } from 'react-router-dom';

const SESSION_KEY = 'webview';
const subscribers = new Set<() => void>();

function subscribe(onStoreChange: () => void) {
  subscribers.add(onStoreChange);
  return () => { subscribers.delete(onStoreChange); };
}

function getSnapshot() {
  return sessionStorage.getItem(SESSION_KEY) === '1';
}

export const useWebview = () => {
  const [searchParams] = useSearchParams();
  const fromUrl = searchParams.get('webview') === '1';

  // Write synchronously during render so sessionStorage is set before any
  // navigation happens — fixes the race where useEffect hadn't fired yet.
  if (fromUrl && !getSnapshot()) {
    sessionStorage.setItem(SESSION_KEY, '1');
    subscribers.forEach(fn => fn());
  }

  return useSyncExternalStore(subscribe, getSnapshot);
};
